import React, { forwardRef } from 'react'
import styled from 'styled-components'
import useScreenType from 'components/ProjectNonSpecificComponents/Hooks/useScreenType'

interface Props extends React.ComponentProps<'div'> {}

const H2 = forwardRef<HTMLDivElement, Props>(
  ({
    style,
    ...props
  }, ref) => {
    const { isMobile } = useScreenType()

    return (
      <CustomText
        {...props}
        style={{
          fontSize: isMobile ? 18 : 36,
          letterSpacing: isMobile ? undefined : '.067em',
          ...style,
        }}
        ref={ref}
      />
    )
  }
)

export default H2

const CustomText = styled.div`
  color: var(--blackish-gray);
  font-weight: bold;
`
